import { createIcon } from '@chakra-ui/react';

export const FireIcon = createIcon({
  displayName: 'FireIcon',
  viewBox: '0 0 22 30',
  path: [
    <path
      key="1"
      opacity="1"
      d="M0.142658 21.8707C1.00102 27.0952 5.66894 29.4671 7.8956 30C6.53426 28.7302 4.16461 25.0952 5.57675 20.7143C6.9889 16.3333 10.0416 13.6961 11.3915 12.9252C7.48038 18.8095 10.0416 23.7755 12.5336 23.9456C14.5272 24.0816 14.8641 22.3923 14.7834 21.5306C18.4937 25.2041 16.4678 28.4807 14.991 29.6599C24.7653 25.034 22.2248 16.576 19.7328 12.9252C20.1135 15.1701 18.1407 16.8707 16.2024 15.7823C14.2642 14.6939 14.991 12.9932 15.3025 11.9728C15.614 10.9524 16.3409 8.33333 14.991 5.13605C13.9112 2.57823 11.2415 0.646259 10.0416 0C10.2839 3.43537 8.69166 5.7483 6.51115 8.33333C4.33063 10.9184 -0.930294 15.3401 0.142658 21.8707Z"
      fill="#FA6B25"
    />
  ]
});
